<template>
  <div>
    <h3>{{ $t('community-analysis') }}</h3>
    <h4>{{ $t('permit-activity-by-community') }}</h4>
    <div class="table-responsive"> 
      <table class="table table-striped table-bordered">
      <thead>
        <tr>
          <th scope="col" rowspan="3">{{ $t('community') }}</th>
          <th scope="col" colspan="6">{{ $t('value-in-thousands') }}</th>
          <th scope="col" colspan="6">{{ $t('number-permits-issued') }}</th>
        </tr>
        <tr>
          <th scope="col" colspan="3">{{ $t('month') }}</th>
          <th scope="col" colspan="3">{{ $t('year-to-date') }}</th>
          <th scope="col" colspan="3">{{ $t('month') }}</th>
          <th scope="col" colspan="3">{{ $t('year-to-date') }}</th>
        </tr>
        <tr>
          <th scope="col">
            {{ curYear }}
          </th>
          <th scope="col">
            {{ lastYear }}
          </th>
          <th scope="col">{{ $t('change') }}</th>
          <th scope="col">
            {{ curYear }}
          </th>
          <th scope="col">
            {{ lastYear }}
          </th>
          <th scope="col">{{ $t('change') }}</th>
          <th scope="col">
            {{ curYear }}
          </th>
          <th scope="col">
            {{ lastYear }}
          </th>
          <th scope="col">{{ $t('change') }}</th>
          <th scope="col">
            {{ curYear }}
          </th>
          <th scope="col">
            {{ lastYear }}
          </th>
          <th scope="col">{{ $t('change') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(res, i) in response09" :key="i">
          <td scope="row">{{ res.community }}</td>
          <td>
            {{ res.curr_mon_value_total | currency($LANG) }}
          </td>
          <td>
            {{ res.prev_mon_value_total | currency($LANG) }}
          </td>
          <td>{{ res.mon_value_pct_change | percent($LANG) }}</td>
          <td>
            {{ res.curr_ytd_value_total | currency($LANG) }}
          </td>
          <td>
            {{ res.prev_ytd_value_total | currency($LANG) }}
          </td>
          <td>{{ res.ytd_value_pct_change | percent($LANG) }}</td>
          <td>{{ res.curr_mon_permit_total }}</td>
          <td>{{ res.prev_mon_permit_total }}</td>
          <td>{{ res.mon_permit_pct_change | percent($LANG) }}</td>
          <td>{{ res.curr_ytd_permit_total }}</td>
          <td>{{ res.prev_ytd_permit_total }}</td>
          <td>{{ res.ytd_permit_pct_change | percent($LANG) }}</td>
        </tr>
      <tr>
          <th>{{ $t('total') }}</th>
          <td>
            {{ total.curr_mon_value_total | currency($LANG) }}
          </td>
          <td>
            {{ total.prev_mon_value_total | currency($LANG) }}
          </td>
          <td>{{ total.mon_value_pct_change | percent($LANG) }}</td>
          <td>
            {{ total.curr_ytd_value_total | currency($LANG) }}
          </td>
          <td>
            {{ total.prev_ytd_value_total | currency($LANG) }}
          </td>
          <td>{{ total.ytd_value_pct_change | percent($LANG) }}</td>
          <td>{{ total.curr_mon_permit_total }}</td>
          <td>{{ total.prev_mon_permit_total }}</td>
          <td>{{ total.mon_permit_pct_change | percent($LANG) }}</td>
          <td>{{ total.curr_ytd_permit_total }}</td>
          <td>{{ total.prev_ytd_permit_total }}</td>
          <td>{{ total.ytd_permit_pct_change | percent($LANG) }}</td>
        </tr>
      </tbody>
    </table>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "CommunityTable",
  props: {
    curYear: String,
    startDate: String,
    endDate: String,
  },

  data() {
    return {
      response09: [],
      response10: [],
    }
  },

  created() {
    this.fetchData();
  },

  watch: {
    endDate() {
      this.fetchData();
    }
  },

  methods: {
    fetchData() {
      const startDate = this.startDate;
      const endDate = this.endDate;
    // Permit Activity by Community
      // By Community
      const request09 = axios.get(
        `${this.$PERMIT_API}?$select=community, sum(case(issue_date='${endDate}',declared_construction_value,true,0)) as curr_mon_value_total, sum(case(issue_date='${startDate}',declared_construction_value,true,0)) as prev_mon_value_total, round(100*(sum(case(issue_date='${endDate}',declared_construction_value,true,0))/sum(case(issue_date='${startDate}',declared_construction_value,true,0)) - 1),0) as mon_value_pct_change, sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),declared_construction_value,true,0)) as curr_ytd_value_total, sum(case(date_trunc_y(issue_date)=date_trunc_y('${startDate}'),declared_construction_value,true,0)) as prev_ytd_value_total, round(100*(sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),declared_construction_value,true,0))/sum(case(date_trunc_y(issue_date)=date_trunc_y('${startDate}'),declared_construction_value,true,0)) - 1),0) as ytd_value_pct_change, sum(case(issue_date='${endDate}',permit_count,true,0)) as curr_mon_permit_total, sum(case(issue_date='${startDate}',permit_count,true,0)) as prev_mon_permit_total, round(100*(sum(case(issue_date='${endDate}',permit_count,true,0))/sum(case(issue_date='${startDate}',permit_count,true,0)) - 1),0) as mon_permit_pct_change, sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),permit_count,true,0)) as curr_ytd_permit_total, sum(case(date_trunc_y(issue_date)=date_trunc_y('${startDate}'),permit_count,true,0)) as prev_ytd_permit_total, round(100*(sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),permit_count,true,0))/sum(case(date_trunc_y(issue_date)=date_trunc_y('${startDate}'),permit_count,true,0)) - 1),0) as ytd_permit_pct_change&$where=(issue_date between date_trunc_y('${endDate}') and '${endDate}' or issue_date between date_trunc_y('${startDate}') and '${startDate}')&$group=community`
      );
      // Total
      const request10 = axios.get(
        `${this.$PERMIT_API}?$select=sum(case(issue_date='${endDate}',declared_construction_value,true,0)) as curr_mon_value_total, sum(case(issue_date='${startDate}',declared_construction_value,true,0)) as prev_mon_value_total, round(100*(sum(case(issue_date='${endDate}',declared_construction_value,true,0))/sum(case(issue_date='${startDate}',declared_construction_value,true,0)) - 1),0) as mon_value_pct_change, sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),declared_construction_value,true,0)) as curr_ytd_value_total, sum(case(date_trunc_y(issue_date)=date_trunc_y('${startDate}'),declared_construction_value,true,0)) as prev_ytd_value_total, round(100*(sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),declared_construction_value,true,0))/sum(case(date_trunc_y(issue_date)=date_trunc_y('${startDate}'),declared_construction_value,true,0)) - 1),0) as ytd_value_pct_change, sum(case(issue_date='${endDate}',permit_count,true,0)) as curr_mon_permit_total, sum(case(issue_date='${startDate}',permit_count,true,0)) as prev_mon_permit_total, round(100*(sum(case(issue_date='${endDate}',permit_count,true,0))/sum(case(issue_date='${startDate}',permit_count,true,0)) - 1),0) as mon_permit_pct_change, sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),permit_count,true,0)) as curr_ytd_permit_total, sum(case(date_trunc_y(issue_date)=date_trunc_y('${startDate}'),permit_count,true,0)) as prev_ytd_permit_total, round(100*(sum(case(date_trunc_y(issue_date)=date_trunc_y('${endDate}'),permit_count,true,0))/sum(case(date_trunc_y(issue_date)=date_trunc_y('${startDate}'),permit_count,true,0)) - 1),0) as ytd_permit_pct_change&$where=(issue_date between date_trunc_y('${endDate}') and '${endDate}' or issue_date between date_trunc_y('${startDate}') and '${startDate}')`
      );

      const self = this;
      axios
        .all([
          request09,
          request10,
        ])
        .then(
          axios.spread(function (
            response09,
            response10,
          ) {
            self.response09 = response09.data;
            self.response10 = response10.data;
          })
        );
    }
  },

  computed: {
    lastYear() {
      return parseInt(this.curYear) - 1;
    },
    total() {
      if (this.response10.length === 0)
        return {
          curr_mon_permit_total: "",
          curr_mon_value_total: "",
          curr_ytd_permit_total: "",
          curr_ytd_value_total: "",
          mon_permit_pct_change: "",
          mon_value_pct_change: "",
          prev_mon_permit_total: "",
          prev_mon_value_total: "",
          prev_ytd_permit_total: "",
          prev_ytd_value_total: "",
          ytd_permit_pct_change: "",
          ytd_value_pct_change: "",
        };
      return this.response10[0];
    },
  },
};
</script>
